import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ReportViewerModule } from 'ngx-ssrs-reportviewer';
import { LocalStorageService } from 'ngx-webstorage';
import { URLsConfig } from 'src/app/URLsConfig';

@Component({
  selector: 'app-reportdialog',
  templateUrl: './reportdialog.component.html',
  styleUrls: ['./reportdialog.component.css']
})
export class ReportdialogComponent implements OnInit {
  private sub: any;
  reportServer: string = this.urlsconfig.WebReportsURL;
  //reportServer: string = 'http://desktop-se4svqd:81/ReportServer';
  //reportServer: string = 'http://192.168.1.198/ReportServer';
  //reportUrl: string = '';
  showParameters: string = 'true';
  parameters: any = {};
  language: string = 'en-us';
  width: number = 100;
  height: number = 100;
  toolbar: string = 'true';
  ReportURL0 =  'CocReports/PreparationOrder_D';
  submitClicked: any;
  @Input() reportUrl: string;
  constructor(public routeparams: ActivatedRoute,
    public storage: LocalStorageService,
    public urlsconfig: URLsConfig,
    @Inject(MAT_DIALOG_DATA) public data :any,
    public dialogRef: MatDialogRef<ReportdialogComponent>,) {
    this.ReportURL0 =  data.reportUrl;
    }

  ngOnInit(): void {

    this.dialogRef.updateSize('80vw', '100vh');
    const par1 = this.storage.retrieve('stgPar');

     //this.storage.store('stgPar', this.patientcode);
     //this.storage.store('stgDate', this.docDate);
     //this.storage.store('stgSource', this.cmsource);


    if(this.ReportURL0 == 'CocReports/PreparationOrder_D'){
       this.parameters ={ PrepCode: this.storage.retrieve('stgPar') };
    }
    if(this.ReportURL0 == 'CocReports/ReqLab' || this.ReportURL0 == 'CocReports/ReqScan'){
      this.parameters = { PatientCode: this.storage.retrieve('stgPar'),CMDate: this.storage.retrieve('stgDate') };
   }
   if(this.ReportURL0 == 'CocReports/Prescription'){
    this.parameters = { PatientCode: this.storage.retrieve('stgPar'),CMDate: this.storage.retrieve('stgDate'),CMSource : this.storage.retrieve('stgSource')};

 }
    this.reportUrl = this.ReportURL0 ;


  }
  Exit_Dialog(){
    this.dialogRef.close();
  }
}
